// JEW: a filter Value picker can hold many options with the same label (442 customers named "JEWSON
// LTD" on TEST). When labels are shared, every option gets a pickerLabel the picker shows instead, with
// what tells them apart: account code, postcode, town, and the id when nothing else does. Only the
// display changes: the condition value is still read from the field's own key (conditionValueFor) and
// the id still goes as dbValue.
const TELL_APART = ['custCode', 'accountCode', 'tasCode', 'postCode', 'cityTown', 'townCity']

const plain = v => (typeof v === 'string' ? v.trim() : typeof v === 'number' ? String(v) : '')

export function withPickerLabels(rows, key) {
  if (!Array.isArray(rows) || !rows.length || !key) return rows
  const count = {}
  rows.forEach(r => {
    const label = plain(r && r[key])
    count[label] = (count[label] || 0) + 1
  })
  if (!Object.values(count).some(n => n > 1)) return rows

  const withExtras = rows.map(r => {
    const label = plain(r && r[key])
    if (count[label] < 2) return { row: r, label, extras: [] }
    const extras = TELL_APART.map(k => plain(r[k])).filter(Boolean)
    return { row: r, label, extras }
  })
  const seen = {}
  withExtras.forEach(x => {
    const text = x.label + '|' + x.extras.join(', ')
    seen[text] = (seen[text] || 0) + 1
  })
  return withExtras.map(x => {
    if (count[x.label] < 2) return { ...x.row, pickerLabel: x.label }
    const extras = [...x.extras]
    const stillShared = seen[x.label + '|' + x.extras.join(', ')] > 1 || !extras.length
    const id = x.row.customerId || x.row.id
    if (stillShared && id !== undefined && id !== null) extras.push('#' + id)
    return { ...x.row, pickerLabel: extras.length ? `${x.label} (${extras.join(', ')})` : x.label }
  })
}

// the option key FilterForm.get4Label shows for a field, given its options
export function pickerLabelKey(field, rows) {
  const first = (rows && rows[0]) || {}
  if (field.dbNameField && first[field.dbNameField] !== undefined) return field.dbNameField
  if (field.dbField && first[field.dbField] !== undefined) return field.dbField
  const segments = (field.dbField || '').split('.')
  return segments[segments.length - 1]
}
